import styled, { css, keyframes } from 'styled-components'

const animation = keyframes`
  0% {
    transform: scale(1.15);
    opacity: 1;
  }

  45% {
    opacity: 0.3;
    transform: scale(0.85);
  }

  100% {
    opacity: 1;
    transform: scale(1.15);
  }
`

const getIconFill = (props: any) => {
  return props.isAdded
    ? props.theme.palette.primary.alpha
    : (
      props.isLoading ? props.theme.palette.primary.alpha : 'transparent'
    )
}

export const Container = styled.div<{ isLoading?: boolean, isAdded?: boolean }>`
  svg {
    cursor: ${props => props.isLoading ? 'wait' : 'pointer'};
    width: 20px;
    height: 20px;
    stroke: ${props => props.isAdded ? 'transparent' : props.theme.palette.general.greyDark};
    fill: ${props => getIconFill(props)};
    transition: all 300ms ease;
    opacity: 1;
    transform: scale(1);
    ${props => props.isLoading && css`
      animation: 1.2s ease-in-out 0s infinite normal none running ${animation};
      stroke: transparent;
    `}

    &:hover,
    &:focus {
      fill: ${props => props.theme.palette.primary.alpha};
    }
  }
`
